export default function (array, property) {
  if (!array || !array.length) {
    return [];
  }

  return array.map((item) => item[property]);
}
